import { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useMaintenance } from '../../contexts/MaintenanceContext';
import { getActivePackItems } from '../../utils/adhkar-packs';
import { defaultAdhkar } from '../../services/offlineAdhkar';

export default function AdhkarOfflineSync() {
  const { currentUserId, loading } = useAuth();
  const { online, blocked, checking, error } = useMaintenance();
  useEffect(() => {
    if (!currentUserId || loading || !online || blocked || checking || error) return;
    // Warm only the two selected packs; never download the pack catalogue.
    void Promise.allSettled(['morning', 'evening'].map(kind =>
      getActivePackItems(currentUserId, kind, defaultAdhkar(kind))));
  }, [currentUserId, loading, online, blocked, checking, error]);
  return null;
}
